import { Language } from "i18n";

export interface IOnboardingMeta {
    id: string;
    pathname: string;
    lang?: Language;
}

export const onboardingMeta: IOnboardingMeta[] = [
    { id: "challenge_v1_our", pathname: "challenge_v1" },
    { id: "product_v1", pathname: "product_v1" },
    { id: "product_v2", pathname: "product_v2" },
    { id: "product_v3", pathname: "product_v3" },
    { id: "product_v4", pathname: "product_v4" },
    { id: "challenge_v2_our", pathname: "challenge_v2" },
    { id: "challenge_100k", pathname: "challenge_100k" },
    { id: "challenge_100k_v2", pathname: "challenge_100k_v2" },
    { id: "challenge_100k_v3", pathname: "challenge_100k_v3" },
    { id: "challenge_100k_v4", pathname: "challenge_100k_v4" },
    { id: "challenge_100k_v5", pathname: "challenge_100k_v5" },
    { id: "challenge_100k_v6", pathname: "challenge_100k_v6" },
    { id: "challenge_100k_v7", pathname: "challenge_100k_v7" },
    { id: "challenge_100k_v7_ecommpay", pathname: "challenge_100k_v7_ecommpay" },
    { id: "challenge_100k_v8", pathname: "challenge_100k_v8" },
    { id: "challenge_100k_v8_s", pathname: "challenge_100k_v8_s" },
    { id: "challenge_100k_v8_e", pathname: "challenge_100k_v8_e" },
    { id: "challenge_100k_v8_es", pathname: "challenge_100k_v8_es", lang: Language.ES },
    { id: "challenge_100k_v8_1", pathname: "challenge_100k_v8_1" },
    { id: "challenge_100k_v8_2", pathname: "challenge_100k_v8_2" },
    { id: "challenge_100k_v8_3", pathname: "challenge_100k_v8_3" },
    { id: "challenge_100k_v8_4", pathname: "challenge_100k_v8_4" },
    { id: "challenge_100k_v9", pathname: "challenge_100k_v9" },
    { id: "email_onboarding", pathname: "email" },
    { id: "challenge_apple", pathname: "challenge_apple" },
    { id: "challenge_apple_v2", pathname: "challenge_apple_v2" }
];
